module.exports = class Carousel {
  constructor({ elem }) {
    this.elem = elem;

    this.list = elem.querySelector('[data-slides]');

    this.arrowLeft = elem.querySelector('[data-arrow-left]');
    this.arrowRight = elem.querySelector('[data-arrow-right]');
    this.position = 0;

    this.arrowRight.onclick = this.next.bind(this);
    this.arrowLeft.onclick = this.prev.bind(this);

    this.render();
  }

  next() {
    // guard against external calls
    if (this.position == this.list.children.length - 1) return;
    this.position++;
    this.render();
  }

  setPosition(position) {
    this.position = position;
    this.render();
  }

  prev() {
    if (this.position == 0) return;
    this.position--;
    this.render();
  }

  render() {
    this.list.style.transform = this.position ? `translate3d(-${this.position}00%,0,0)` : '';

    if (this.position === 0) {
      this.arrowLeft.setAttribute('data-arrow-hidden', 1);
    } else {
      this.arrowLeft.removeAttribute('data-arrow-hidden');
    }

    if (this.position == this.list.children.length - 1) {
      this.arrowRight.setAttribute('data-arrow-hidden', 1);
    } else {
      this.arrowRight.removeAttribute('data-arrow-hidden');
    }
  }
};
